/**
 * Modal Index - Vue.js Component Registration
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'modal';
const log = debug(MODULE_NAME);

//
// Dependencies
const Vue = window.Vue;
import { ModalComponent } from './components/modal';

//
// Exports
export function exec () {
	log('Running...');	

	log(`Vue: registering <modal>`);
	Vue.component('modal', ModalComponent);	
}

export {exec as default};




// WEBPACK FOOTER //
// ./project/client/src/core/modules/modal/index.js